import { Injectable } from '@angular/core';
import Phaser from 'phaser';
import { closeFullscreen, openFullscreen } from '../utils/full-screen';
import { Zoom } from '../common/enums/zoom';

@Injectable({
  providedIn: 'root',
})
export class ToolboxActionService {
  public phaser!: Phaser.Game;
  private isFullScreen = false;

  constructor() {}

  public initGame(phaser: Phaser.Game) {
    this.phaser = phaser;
  }

  public handleFullScreenClick(): void {
    this.isFullScreen ? closeFullscreen() : openFullscreen();
    this.isFullScreen = !this.isFullScreen;
  }

  public handleZoomClick(zoomType: Zoom, mouseLeave?: boolean): void {
    (this.phaser.scene.getScenes(true)[0] as any)?.handleZoomClick?.(
      zoomType,
      mouseLeave
    );
  }
}
